import { Filter } from '../../../../hooks/filters/interfaces/filter.interface';
import { FilterButtonDropdownStandAloneComponent } from '../filter-button-dropdown/filter-button-dropdown-stand-alone.component';
import { FilterPaneHeaderCommonComponentProps } from './filter-pane-header.component';
import './filter-pane-header.component.scss';

export interface FilterPaneHeaderComponentStandAloneProps
  extends FilterPaneHeaderCommonComponentProps {
  filters?: Filter[];
  disabledList?: Record<string, boolean>;
}

export const FilterPaneHeaderStandAloneComponent = ({
  onSelect,
  filters,
  filterSelection,
  variant = 'stand-alone',
  disabled,
  disabledList,
  defaultLabel,
}: FilterPaneHeaderComponentStandAloneProps) => (
  <div className="filter-pane-header-container">
    {filters?.map(
      (filter, index) =>
        filter && (
          <div className="filter-pane-header-item" key={filter.id}>
            <FilterButtonDropdownStandAloneComponent
              onSelect={onSelect}
              variant={variant}
              key={index}
              filter={filter}
              filterSelection={filterSelection}
              disabled={disabledList ? disabledList[filter.id] : disabled}
              defaultLabel={defaultLabel}
            />
          </div>
        ),
    )}
  </div>
);
